export const PROVIDER_DOMAIN = 'EXPERIMENTATION_PROVIDER';
